﻿export function toggleRow2Table(tableClass: string) {
    $("." + tableClass + " .bcfla-tr-dbl-bottom").toggleClass("bcfla-tr-hiddeninfo");
}

export function toggleRow2Tr(trClass:string) {
    $("." + trClass + ".bcfla-tr-dbl-bottom").toggleClass("bcfla-tr-hiddeninfo");
}

export function toggleExpand(icon:HTMLSpanElement, rowClass:string) {
    $("." + rowClass).toggleClass("bcfla-hidden");
    if ($(icon).hasClass("fa-chevron-right")) {
        $(icon).removeClass("fa-chevron-right");
        $(icon).addClass("fa-chevron-down");
    } else {
        $(icon).addClass("fa-chevron-right");
        $(icon).removeClass("fa-chevron-down");
    }
}